import axios from "axios";
import { useCallback, useRef } from "react";
import { useSetRecoilState } from "recoil";
import { useAlert } from "../hooks/useAlert";
import { removeDuplicateMessagesSelector } from "../store/AlertState";
import { makeErrorMessage } from "../utils/ErrorMessageUtil";

export const AxiosErrorHandle = ({ children }) => {
  const {showError} = useAlert();
  const removeDuplicateMessages = useSetRecoilState(removeDuplicateMessagesSelector);

  const removeMessage = useCallback(errorHandle => {
    const errorMessage = makeErrorMessage(errorHandle);
    removeDuplicateMessages(errorMessage);
    return errorMessage;
  }, [removeDuplicateMessages]);

  const isFirstRender = useRef(true);
  if (isFirstRender.current) {
    axios.interceptors.response.use(
      response => {
        if (response.config.errorHandle) {
          removeMessage(response.config.errorHandle);
        }
        return response;
      },
      error => {
        if (error.config.errorHandle && !error.config.errorHandle.exclusionStatus?.includes(error.response?.status)) {
          const errorMessage = removeMessage(error.config.errorHandle);
          showError(errorMessage);
        }
        throw error;
      }
    );
    isFirstRender.current = false;
  }

  return <>{children}</>;
}
